import { __awaiter, __generator } from "tslib";
import { addJsonContentTypeHeader, mergeObjects } from '../utilities';
import { commonFetch } from './common-fetch';
var setJsonBodyFetchOptions = function (fetchOptions, body) {
    if (!fetchOptions.headers) {
        fetchOptions.headers = new Headers();
    }
    addJsonContentTypeHeader(fetchOptions.headers);
    if (body) {
        fetchOptions.body = JSON.stringify(body);
    }
};
var getPostFetchOptions = function (body, options) {
    if (options === void 0) { options = {}; }
    var defaultOptions = { method: 'POST' };
    var fetchOptions = mergeObjects(options, defaultOptions);
    setJsonBodyFetchOptions(fetchOptions, body);
    return fetchOptions;
};
/**
 * Makes a post request and returns result of the response.
 * @param url URL to make a request
 * @param body Body of POST request
 * @param options Additional options for the request
 * @returns Promise with response result or null if response was not successful.
 */
export var fetchPostAsResult = function (url, body, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commonFetch(url, getPostFetchOptions(body, options))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
export var fetchPost = fetchPostAsResult;
/**
 * Makes a post request and returns whole response.
 * @param url URL to make a request
 * @param body Body of POST request
 * @param options Additional options for the request
 * @returns Promise with response or null if response was not successful.
 */
export var fetchPostAsResponse = function (url, body, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, getPostFetchOptions(body, options))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
